import { render, staticRenderFns } from "./AboutUsCard.vue?vue&type=template&id=6caec94e&scoped=true&"
import script from "./AboutUsCard.vue?vue&type=script&lang=js&"
export * from "./AboutUsCard.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AboutUsCard.vue?vue&type=style&index=1&id=6caec94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caec94e",
  null
  
)

export default component.exports